import http from "../../BaseConfigurationApiHttp";

class AccountService {
  getAccount(accountId) {
    return http.get(`accounts/${accountId}`);
  }
}

export default new AccountService();
